import React from "react";
import { Link } from "react-router-dom";

const styles = {
  container: {
    maxWidth: "800px",
    margin: "auto",
    padding: "20px",
    fontFamily: "Arial, sans-serif",
    lineHeight: "1.6",
    color: "#333",
  },
  header: {
    textAlign: "center",
    fontSize: "24px",
    fontWeight: "bold",
    marginBottom: "20px",
  },
  section: {
    marginBottom: "20px",
  },
  backLink: {
    display: "block",
    marginTop: "20px",
    textAlign: "center",
    textDecoration: "none",
    color: "#007bff",
    fontSize: "18px",
  }
};

const RulesAndRegulations = () => {
  return (
    <div style={styles.container}>
      <h1 style={styles.header}>Dola Gi - Hunt your Limits</h1>
      <h2 style={styles.header}> Guidelines </h2>
      
      <div style={styles.section}>
        <h3>Overview of Virtual Team Challenge</h3>
          <p>1. This challenge involves 4 teams.</p>
	  <p>2. Each team has approx 15-20 members.</p>
          <p>3. The challenge will involve two or more events, such as:</p>
           <ul>
            <li>Running, walking or endurance challenge (e.g., 5 KM)</li>
            <li>Strength or mobility-based challenge (e.g., squats, push-ups, etc.)</li>
           </ul>
          <p>4. There will be team and individual winners for each challenge period (e.g., a month).</p>
          <p>5. Team and individual performance will be monitored and displayed on respective leaderboards.</p>
          <p>6. We encourage every member to contribute to the team challenge to maximize their teams score. More participation means more points!</p>
      </div>
      <div style={styles.section}>
	<h3>Rules & Regulations for Virtual Team Challenge:</h3>
        <h3>How to Submit Challenge Data</h3>
        <p>1. Team members must submit challenge data within the given timeframe (a month) for it to count towards the challenge.</p>
        <p>2. Submission must be done via performance screenshots in the BITTRAA Sports and Fitness WhatsApp group.</p>
        <p>3. Fitness apps given below should be used to track performance and submit screen shots. Other apps can be used as well but will not be considered for bonus individual ranking points (refer scoring and points system section #4)
		<ol type = "a">
	  		<li>Strava </li>
	  		<li>Garmin Connect </li>
	  		<li>Nike Run Club </li>
	  		<li>Google Fit  </li>
	  		<li>Adidas </li>

		</ol>  		
        </p>
     
      </div>

      <div style={styles.section}>
        <h3>4. Running or Walking Challenge:</h3>
        <ul>
          <li>a) Outdoor Running or Walking: Submit a screenshot from fitness apps listed above, showing the profile name, distance and time taken. Optionally distance splits, total workout time, calories, step count etc.</li>
          <li>b) Treadmill Running or Walking: Submit following two records:
	    <ul>
	  	<li>i) A photo of treadmill screen showing the final distance and time.</li>
		<li>ii) A screenshot form the fitness app showing the distance, calories, step count, etc. (optional).</li>
	    </ul>
	  </li>
        </ul>
      </div>

      <div style={styles.section}>
        <h3>5. Strength & Mobility Challenge:</h3>
        <ul>
          <li>a) Submit a video demonstrating proper form and completion of the challenge.</li>
          <li>b) Guidelines for each challenge will be provided every month.</li>
          <li>c) Strength and mobility challenges will vary from period to period.</li>
          <li>d) Certain minimum performance criteria must be met to contribute to team challenge e.g. minimum of 10 push-ups with proper form, 30-second plank held in proper form, etc.</li>
	<li>e) Participants may put in maximum effort to compete for individual honors (e.g., perform the highest number of push-ups in a single continuous effort or hold a plank for the longest duration with proper form.</li>
        </ul>
      </div>

      <div style={styles.section}>
        <h3>Scoring & Points System</h3>
        <p>1) Points are awarded based on successful compoletion of challenge.</p>
	<p>2) Each team member who completes the strength, endurance or mobility challenge will earn points for their team.</p>
	<p>3) Each participant completing a challenge will contribute 10 points to the team tally.</p>
	<p>4. Individual Ranking Points:</p>
        <ul>
          <li>A. The top performer in each challenge will earn 10 points.</li>
          <li>B. Next best performer will receive one point less (e.g. the second-place performer will receive 9 points, the third-place will receive 8 points, and so on).</li>
        </ul>
	<p> 5. Early Bird Bonus Point:</p>
	 Entries subimitted by the 15th of each month will receive an additional two points per participant per challenge as an early bird bonus. 

	<p>6. Running, Walking or Endurance Event:</p>
       <ul>
          <li>A. Team cumulative points: As each team member completes the target distance (e.g., every completed 5K run), it adds to the overall team score. The more members who complete the target, the higher the team’s cumulative score.</li>
          <li>B. Individual performance: Each month, a running target will be set (e.g., 5K run). Individual participants will earn points based on their relative best performance in that category.</li>
        </ul>
	<p>7. For Strength & Mobility Challenges:</p>
       <ul>
          <li>A. Team cumulative points: As each team member completes the target performance (e.g., minimum 10 push-ups), it adds to the overall team score. The more members who complete the target, the higher the team’s cumulative score.</li>
          <li>B. Individual Performance: Each participant will earn points based on their individual performance in the challenge. The better the performance, the higher the points awarded (based on time, repetitions or sets, whichever is most suitable).</li>
        </ul>
      </div>


      <div style={styles.section}>
	
        <hr/>
       
	<h3> July 2025 Challenge:</h3>
	<p> 1) 2 KM Distance Challenge:</p>
	<ul>
		<li> a. Participants have to cover 2 KM distance in a continuous run/walk </li>
		<li> b. To complete the challenge minimum 2 entry within the June month is needed. (Single entry will not fetch any team points).</li> 
		<li> c. Maximum 4 entries will be entertained for July 2025.Distance can be covered by run or walk </li>
		<li> d. Entries submitted by the 15th of the month will receive an additional 2 points per participant per challenge as an early bird bonus. So a maximum of 4 early bird points can be early by each participant </li>
		<li> e. Runners can cover more distance, however the first 2 KM split will be considered for Individual performance.</li>
		<li> f. Treadmill can be used but outdoor run/walk is encouraged. </li>
		<li> g. Treadmill performance will be considered for team submissions however, it will not be considered for individual performance ranking.</li>
		<li> h. Submit a screenshot displaying your profile name, distance and time from fitness apps for outdoor run (Strava, Garmin Connect, Nike Run Club, Adidas, and Google Fit).</li>
		<li> i. Other performance metrics like total elapsed time, moving time, distance splits will be needed for individual performance ranking.</li>
		<li> j. Treadmill Running or Walking –  Submit following two records:
 			<ul> 
				<li> A photo of the treadmill screen showing the final distance and time.</li>
 				<li> A screenshot from the fitness app showing the distance, calorie, step counts etc. (optional)</li>
			</ul>
	        </li>
	</ul>


	<p> 2. Strength and Mobility challenge (Wall Sit / Imaginary chair):</p>
	A wall sit is an isometric exercise where you simulate sitting in a chair while leaning against a wall. It primarily strengthens the quadriceps muscles and improves leg endurance. 
	<br/>
	<br/>

	How to perform a wall sit:
	<br/>
	<br/>
	Positioning: Stand with your back against a wall/pillar and your feet hip-width apart, a comfortable distance away from the wall. 
	<br/>
	Lowering: Slowly slide your back down the wall, and slightly move your feet forward until the thighs are parallel to the floor and knees make an angle of  90 degrees, as if you were sitting in a chair. 
	<br/>
	Hold: Hold the position for a minimum of 20 seconds to get the team points. 
	<br/>
	Exiting: To come out of the wall sit, slowly slide your back up the wall. 

	<br/>
	<br/>

	Rules:
	<br/>
	<br/>
	1. Back should be flat against the wall all the time.
	<br/>
	2. Thighs should be parallel to the ground. Knees should make an angle of  90 degrees.
	<br/>
	3. Hands should be away from legs, either at the side or up or behind the head.
	<br/>
	4. No adjustments other than hands are allowed.
	<br/>
	5. Minimum time required to earn team points is 20 seconds.
	<br/>
	<br/>

	Video should be taken from a side angle which will clearly show the knee angle of 90 degrees.
	<br/>
	<br/>
	Benefits:
	<br/>
	1. Strengthens quadriceps: Wall sits primarily target and strengthen the quadriceps muscles. 
	<br/>
	2. Improves endurance: Holding the position builds leg endurance. 
	<br/>
	3. Enhances stability: It can improve stability in the hips, knees, and ankles. 
	<br/>
	4. Relieves knee pain: Wall sits can be beneficial for strengthening muscles that support the knee joint. 
	<br/>
	5. Burns belly fat: Wall sits can engage core muscles, potentially aiding in burning abdominal fat
 
	<hr/>

      </div>
        <hr/>
    </div>
  );
};

export default RulesAndRegulations;

